const PORTAL_HEALTH_STATES = {
  DEFAULT: 'DEFAULT',
  PROBATION_1: 'PROBATION_1',
  PROBATION_2: 'PROBATION_2',
  PROBATION_3: 'PROBATION_3',
  SUSPENDED: 'SUSPENDED'
};
export default PORTAL_HEALTH_STATES;